import { MAX_CAPACITY_TONNES } from '@chukua/common';

/**
 * The capacity field's rules on every truck, trailer and truck class form: the same ceiling the API enforces, so a weight
 * typed in kilograms is caught beside the field rather than after a round trip.
 */
export const CAPACITY_TONNES_RULES = [
  { required: true, message: 'Enter a capacity' },
  {
    type: 'number' as const,
    max: MAX_CAPACITY_TONNES,
    message: `Capacity is in tonnes, up to ${MAX_CAPACITY_TONNES.toLocaleString('en')} t (50,000 kg is 50 t)`,
  },
];
